import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import vueJsonEditor from 'vue-json-editor';

@Component({
    name: 'partner-api-form-data',
    components: {
        'vue-json-editor': vueJsonEditor,
    },
})

export default class PartnerAPIFormData extends Vue {

    // --------------------------------------------------
    // Properties

    public partnerAPIData: any = [];

    @Prop()
    public activeTab: any;

    @Prop()
    public value: any;

    @Prop()
    public formData: any;

    public jsonData: any = {};

    @Prop()
    public connectionMsg!: string;

    @Watch('partnerAPIData', {deep: true})
    public onChangePartner() {
        this.serializeFormData();
    }

    // --------------------------------------------------
    // Hooks

    public created() {
        this.partnerAPIData.push(this.createAPIObj());
        if (this.value && Object.keys(this.value).length) {
            this.parseAPIObj();
        }
    }

    public mounted() {
        this.jsonData = {...this.value};
    }


    // --------------------------------------------------
    // Actions

    public onAdd() {
        this.partnerAPIData.push(this.createAPIObj());
    }

    public onRemove(data: any) {
        this.partnerAPIData.splice(data.index, 1);
    }

    public onJsonChange(value: any) {
        this.$emit('input', value);
    }

    // --------------------------------------------------
    // Method

    private createAPIObj() {
        return {
            key: '',
            value: '',
            action: '',
        };
    }

    private serializeFormData() {
        const partnerAPIData = [...this.partnerAPIData];
        const payload: any = {};
        partnerAPIData.forEach((item) => {
            payload[item.key] = item.value;
        });
        this.$emit('input', payload);
    }

    private parseAPIObj() {
        const value = this.value || {};
        this.partnerAPIData = Object.keys({...value}).map((itemKey) => {
            return {
                key: itemKey,
                value: value[itemKey],
                action: '',
            };
        });
    }
}
